import { SVGProps } from "react";

export const AtlassianGuardLogoBrand = (props: SVGProps<SVGSVGElement>) => {
    return (
        <svg
            viewBox="0 0 171 62"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <g clipPath="url(#clip0_713_48377)">
                <g clipPath="url(#clip1_713_48377)">
                    <g clipPath="url(#clip2_713_48377)">
                        <path
                            d="M1.37669 34.2881H32.6216C33.5194 34.2881 33.9983 33.8092 33.9983 32.9114V22.3767C33.9983 21.4788 33.5194 21 32.6216 21H26.0374C25.1396 21 24.6607 21.4788 24.6607 22.3767V27.7039H21.6679V22.3767C21.6679 21.4788 21.1891 21 20.2912 21H13.707C12.8092 21 12.3304 21.4788 12.3304 22.3767V27.7039H9.33755V22.3767C9.33755 21.4788 8.8587 21 7.96086 21H1.37669C0.478849 21 0 21.4788 0 22.3767V32.9114C0 33.8092 0.478849 34.2881 1.37669 34.2881ZM1.9154 43.5059C1.25698 41.6504 0.837986 39.735 0.718273 37.5203C0.658417 36.7422 1.01755 36.3232 1.85554 36.3232H32.1427C32.9807 36.3232 33.3399 36.6823 33.3399 37.4006C33.2201 39.6153 32.8011 41.6504 32.0829 43.5059C31.7237 44.4636 31.185 44.8826 30.1675 44.8826H3.83079C2.81324 44.8826 2.27453 44.4636 1.9154 43.5059ZM29.6288 48.474C26.7557 52.0055 22.027 54.28 16.9991 54.28C11.9712 54.28 7.12288 52.0055 4.30964 48.474C3.59137 47.5163 3.9505 46.9177 4.66878 46.9177H29.3295C30.0478 46.9177 30.4069 47.5163 29.6288 48.474Z"
                            fill="#1868DB"
                        />
                    </g>
                    <path
                        d="M153.597 40.5002C153.597 46.0202 155.805 48.7802 159.899 48.7802C163.441 48.7802 166.615 46.5262 166.615 41.4202V39.5802C166.615 34.4742 163.717 32.2202 160.359 32.2202C155.897 32.2202 153.597 35.1642 153.597 40.5002ZM166.615 52.0002V47.8602C165.143 50.8962 162.383 52.4602 158.841 52.4602C152.723 52.4602 149.641 47.2622 149.641 40.5002C149.641 34.0142 152.861 28.5402 159.301 28.5402C162.659 28.5402 165.235 30.0582 166.615 33.0482V19.3862H170.571V52.0002H166.615Z"
                        fill="#101214"
                    />
                    <path
                        d="M139.926 38.4301V52.0001H136.062V29.0001H139.926V33.0481C141.26 30.3341 143.56 28.4021 148.068 28.6781V32.5421C143.008 32.0361 139.926 33.5541 139.926 38.4301Z"
                        fill="#101214"
                    />
                    <path
                        d="M113.123 40.5C113.123 46.02 115.331 48.78 119.425 48.78C122.967 48.78 126.141 46.526 126.141 41.42V39.58C126.141 34.474 123.243 32.22 119.885 32.22C115.423 32.22 113.123 35.164 113.123 40.5ZM126.141 52V47.86C124.669 50.896 121.909 52.46 118.367 52.46C112.249 52.46 109.167 47.262 109.167 40.5C109.167 34.014 112.387 28.54 118.827 28.54C122.185 28.54 124.761 30.058 126.141 33.048V29H130.097V52H126.141Z"
                        fill="#101214"
                    />
                    <path
                        d="M85.0203 42.478V29H88.9763V42.892C88.9763 47.032 90.6323 48.872 94.4043 48.872C98.0843 48.872 100.614 46.434 100.614 41.788V29H104.57V52H100.614V48.228C99.1423 50.942 96.4283 52.46 93.3463 52.46C88.0563 52.46 85.0203 48.826 85.0203 42.478Z"
                        fill="#101214"
                    />
                    <path
                        d="M79.0601 50.2985C76.6681 51.7245 72.2521 52.4605 68.8481 52.4605C58.4521 52.4605 52.8401 46.1125 52.8401 36.9585C52.8401 27.1145 59.2341 21.2725 69.9981 21.2725C72.3901 21.2725 75.1961 21.5485 77.8641 22.4685V26.6085C75.5641 25.6885 72.8501 25.2745 70.0441 25.2745C61.0741 25.2745 56.9801 29.7365 56.9801 36.8665C56.9801 43.8585 61.1201 48.5045 69.8141 48.5045C71.2401 48.5045 73.2181 48.3665 74.9201 47.8605V39.4425H67.1921V35.4865H79.0601V50.2985Z"
                        fill="#101214"
                    />
                </g>
                <path
                    d="M106.96 8.06C106.96 6.01 105.66 5.14 103.21 4.53C101.67 4.14 101.31 3.81 101.31 3.3C101.31 2.69 101.85 2.38 102.86 2.38C104.08 2.38 105.29 2.77 106.43 3.32V0.76C105.63 0.33 104.28 0 102.93 0C100.26 0 98.77 1.28 98.77 3.36C98.77 5.44 100.08 6.35 102.33 6.85C103.88 7.19 104.36 7.45 104.36 8.12C104.36 8.63 103.99 9.04 102.81 9.04C101.43 9.04 99.78 8.55 98.71 7.87V10.56C99.56 11.01 101 11.5 102.79 11.5C105.61 11.5 106.95 10.13 106.95 8.06H106.96Z"
                    fill="#1868DB"
                />
                <path
                    d="M137.68 0.160156V11.3402H140.05V2.83016L141.05 5.09016L144.41 11.3502H147.4V0.170156H145.03V7.39016L144.13 5.30016L141.43 0.170156H137.69L137.68 0.160156Z"
                    fill="#1868DB"
                />
                <path
                    d="M122.6 0.160156H120V11.3402H122.6V0.160156Z"
                    fill="#1868DB"
                />
                <path
                    d="M78.6499 0.160156V11.3402H83.9699L84.8099 8.92016H81.2499V0.160156H78.6499Z"
                    fill="#1868DB"
                />
                <path
                    d="M68.1101 0.160156V2.58016H71.0001V11.3402H73.6001V2.58016H76.6901V0.160156H68.1101Z"
                    fill="#1868DB"
                />
                <path
                    d="M64.32 0.160156H60.9L57 11.3402H59.97L60.52 9.45016C61.18 9.64016 61.87 9.76016 62.61 9.76016C63.35 9.76016 64.02 9.66016 64.7 9.45016L65.25 11.3402H68.22L64.3 0.160156H64.32ZM62.6 7.46016C62.11 7.46016 61.62 7.38016 61.16 7.25016L62.6 2.36016L64.04 7.25016C63.59 7.37016 63.12 7.46016 62.6 7.46016Z"
                    fill="#1868DB"
                />
                <path
                    d="M93.1801 0.160156H89.7601L85.8601 11.3402H88.8301L89.3801 9.45016C90.0401 9.64016 90.7301 9.76016 91.4701 9.76016C92.2101 9.76016 92.8801 9.66016 93.5601 9.45016L94.1101 11.3402H97.0801L93.1601 0.160156H93.1801ZM91.4601 7.46016C90.9701 7.46016 90.4801 7.38016 90.0201 7.25016L91.4601 2.36016L92.9001 7.25016C92.4501 7.37016 91.9601 7.46016 91.4601 7.46016Z"
                    fill="#1868DB"
                />
                <path
                    d="M131.93 0.160156H128.51L124.61 11.3402H127.58L128.13 9.45016C128.79 9.64016 129.48 9.76016 130.22 9.76016C130.96 9.76016 131.63 9.66016 132.31 9.45016L132.86 11.3402H135.83L131.91 0.160156H131.93ZM130.23 7.46016C129.74 7.46016 129.25 7.38016 128.79 7.25016L130.23 2.36016L131.67 7.25016C131.2 7.37016 130.73 7.46016 130.23 7.46016Z"
                    fill="#1868DB"
                />
                <path
                    d="M117.32 8.06C117.32 6.01 116.02 5.14 113.57 4.53C112.03 4.14 111.67 3.81 111.67 3.3C111.67 2.69 112.21 2.38 113.22 2.38C114.44 2.38 115.65 2.77 116.79 3.32V0.76C115.99 0.33 114.64 0 113.29 0C110.62 0 109.13 1.28 109.13 3.36C109.13 5.44 110.44 6.35 112.69 6.85C114.24 7.19 114.72 7.45 114.72 8.12C114.72 8.63 114.35 9.04 113.17 9.04C111.79 9.04 110.14 8.55 109.07 7.87V10.56C109.92 11.01 111.36 11.5 113.15 11.5C115.97 11.5 117.31 10.13 117.31 8.06H117.32Z"
                    fill="#1868DB"
                />
            </g>
            <defs>
                <clipPath id="clip0_713_48377">
                    <rect width="171" height="62" fill="white" />
                </clipPath>
                <clipPath id="clip1_713_48377">
                    <rect
                        width="171"
                        height="48"
                        fill="white"
                        transform="translate(0 14)"
                    />
                </clipPath>
                <clipPath id="clip2_713_48377">
                    <rect
                        width="33.9983"
                        height="33.28"
                        fill="white"
                        transform="translate(0 21)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};
